module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"noItemsText":"Tällä hetkellä yhtäkään vaalipeliä ei ole käynnissä."}}')
  delete Component.options._Ctor
}
